import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef, inject} from '@angular/core';
import {Subject} from 'rxjs';
import {UserInfoQuery} from '../elf-store/user-info/user-info.query';
import {findValueByKey} from '../utils/helpers';
import {OnlyRegTrackModeSettings} from '../../types/only-reg-track-mode.type';
import {userInfoStore} from '../elf-store/user-info/user-info.store';

const excludedUIComponents: OnlyRegTrackModeSettings = {
  header: {
    searchField: true,
    headerControls: true,
  },
  navigation: {
    addSiteBtn: true,
    becomePartnerUrl: true,
  },
  userMenu: {
    subscriptions: true,
    billing: true,
  },
};

@Directive({
  standalone: true,
  selector: '[onlyRegTrackModeGuard]',
})
export class OnlyRegTrackModeGuardDirective implements OnDestroy {
  private viewContainer = inject(ViewContainerRef);
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private userQuery = inject(UserInfoQuery);

  private onDestroy$ = new Subject<boolean>();
  private isComponentExcluded(componentName: string): boolean {
    return findValueByKey(excludedUIComponents, componentName);
  }

  @Input() set onlyRegTrackModeGuard(componentName: string) {
    const isRegulationMode = userInfoStore.getValue().userInfo?.regulation_tracker_mode_only;
    const isExclude = this.isComponentExcluded(componentName);
    const shouldDisplayContent = !isRegulationMode || !isExclude;

    this.viewContainer.clear();

    if (shouldDisplayContent) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
